module.exports = __webpack_public_path__ + "static/media/headerWithoutImageRightGraphic.c40f40e6.svg";